__turbopack_context__.v({
  "classic_black_scrollbar": "styles-module-scss-module__4X0FYG__classic_black_scrollbar",
  "classic_bright_blue_scrollbar": "styles-module-scss-module__4X0FYG__classic_bright_blue_scrollbar",
  "classic_dusty_pink_scrollbar": "styles-module-scss-module__4X0FYG__classic_dusty_pink_scrollbar",
  "classic_green_scrollbar": "styles-module-scss-module__4X0FYG__classic_green_scrollbar",
  "classic_light_orange_scrollbar": "styles-module-scss-module__4X0FYG__classic_light_orange_scrollbar",
  "classic_steel_blue_scrollbar": "styles-module-scss-module__4X0FYG__classic_steel_blue_scrollbar",
  "classic_teal_blue_scrollbar": "styles-module-scss-module__4X0FYG__classic_teal_blue_scrollbar",
  "classic_yellow_orange_scrollbar": "styles-module-scss-module__4X0FYG__classic_yellow_orange_scrollbar",
  "report-scroll-bar": "styles-module-scss-module__4X0FYG__report-scroll-bar",
});
